<template>
  <div style="width: 100%;height: 100%;">
    <l-map style="width: 100%;height: 100%;position: relative;background: black" ref="map"  :options="option">
      <l-tile-layer style="margin: 0 auto" :url="tifLayer" :tms="true"/>
    </l-map>
  </div>
</template>
<script>

import L from "leaflet";
import {LMap,LTileLayer} from 'vue2-leaflet';

export default {
  name: "ImageLayer",
  components: {
    LMap,
    LTileLayer,
  },
  mounted() {
    this.initMap()
    // this.initLayer()
  },
  data(){
    return {
      tifLayer:'',
      option: {zoomControl: false, attributionControl: false, renderer: L.canvas(),zoomSnap:0.01,scrollWheelZoom:true, dragging:true},
    }
  },
  methods:{
    async initMap() {
      await this.$refs.map.mapObject.on('zoomend', (e) => {
        this.zoom = e.target._zoom
      });
    },
    updatedLayer(cite,bounds){
      this.$refs.map.mapObject.setMinZoom(0)
      this.tifLayer = 'https://tile.charmingglobe.com/map/dataset/'+cite+'/{z}/{x}/{y}?token=Bearer%20a84a40c81f784490a4c5689187054abf';
      this.$refs.map.mapObject.fitBounds(L.geoJSON(JSON.parse(bounds)).getBounds())
      this.$refs.map.mapObject.zoomIn(0.01)
      this.$refs.map.mapObject.setMaxBounds(L.geoJSON(JSON.parse(bounds)).getBounds())
      this.zoom = this.$refs.map.mapObject.getZoom()
      this.$refs.map.mapObject.setMinZoom(this.zoom + 0.01)
    },
    zoomIn(){
      this.$refs.map.mapObject.zoomIn(0.5)
    },
    zoomOut(){
      this.$refs.map.mapObject.zoomOut(0.5)
    },
    centerLayer(bounds){
      this.$refs.map.mapObject.fitBounds(L.geoJSON(JSON.parse(bounds)).getBounds())
    }
  }
}
</script>

<style scoped>


</style>